export default __webpack_public_path__ + "static/media/editbtn.8bddda0f.svg";